import { callApi } from '@/shared/api/http';
import type { RegisterRequest, LoginRequest, UpdateProfileRequest, AuthResponse, UserResponse, LogoutResponse, DeleteAccountResponse } from './types';

/**
 * Register a new user
 * POST /register
 */
export const register = async (data: RegisterRequest) => {
    return callApi<AuthResponse, RegisterRequest>('register', data, 'post');
};

/**
 * Login user
 * POST /login
 */
export const login = async (data: LoginRequest) => {
    return callApi<AuthResponse, LoginRequest>('login', data, 'post');
};

/**
 * Get authenticated user profile
 * GET /me
 */
export const getMe = async () => {
    return callApi<UserResponse>('me', null, 'get');
};

/**
 * Update user profile
 * PUT /me
 */
export const updateMe = async (data: UpdateProfileRequest) => {
    return callApi<UserResponse, UpdateProfileRequest>('me', data, 'put');
};

/**
 * Logout user
 * POST /logout
 */
export const logout = async () => {
    return callApi<LogoutResponse>('logout', null, 'post');
};

/**
 * Request password reset email
 * POST /forgot-password/
 */
export const forgotPassword = async (data: { email: string }) => {
    return callApi<{ success: boolean; message: string; status_code: number }, { email: string }>('forgot-password/', data, 'post');
};

/**
 * Complete password reset
 * POST /forgot-password/confirm/
 */
export const resetPassword = async (data: { token: string; password: string }) => {
    return callApi<{ success: boolean; message: string; status_code: number; status?: string }, { token: string; password: string }>('forgot-password/confirm/', data, 'post');
};

/**
 * Delete user account
 * DELETE /me
 */
export const deleteAccount = async () => {
    return callApi<DeleteAccountResponse>('me', null, 'delete');
};
